import { render } from "./scorm.svg?vue&type=template&id=4ed7cf30"
const script = {}
script.render = render

export default script